import { gql, Resolver } from '@apollo/client';
import axios from 'axios';

/**
 * @typedef {RegisterInvitedUserArgs}
 * @property {string} company form input for company
 * @property {string} email email address that has been confirmed as an invited user
 * @property {string} firstName form input for first name
 * @property {string} lastName form input for first name
 * @property {string} password form input for password
 * @property {string} registerInvitedUserUrl URL for the endpoint to register an invited user
 * @property {string} statementId the statement ID used during onboarding to render
 * StatementsPreview charts
 */
interface RegisterInvitedUserArgs {
    company: string;
    email: string;
    firstName: string;
    lastName: string;
    password: string;
    registerInvitedUserUrl: string;
    statementId: string;
}

/**
 * Register a user that has an email address that was confirmed to be on the invitation list.
 * @param obj
 * @param {RegisterInvitedUserArgs} args
 * @param context
 */
export const registerInvitedUser: Resolver = async (
    obj: Record<string, unknown>,
    args: RegisterInvitedUserArgs,
): Promise<{ status: string; message: string } | Error> => {
    const {
        company,
        email,
        firstName,
        lastName,
        password,
        registerInvitedUserUrl,
        statementId,
    } = args;

    const result = await axios({
        method: 'post',
        url: registerInvitedUserUrl,
        data: {
            company,
            email: email.toLowerCase(),
            first_name: firstName,
            last_name: lastName,
            password,
            statement_id: statementId,
        },
    });

    return result.data;
};

export const REGISTER_INVITED_USER = gql`
    mutation RegisterInvitedUser(
        $company: String!
        $email: String!
        $firstName: String!
        $lastName: String!
        $password: String!
        $registerInvitedUserUrl: String!
        $statementId: String!
    ) {
        registerInvitedUser(
            company: $company
            email: $email
            firstName: $firstName
            lastName: $lastName
            name: $name
            password: $password
            registerInvitedUserUrl: $registerInvitedUserUrl
            statementId: $statementId
        ) @client
    }
`;
